import React, { useReducer, useCallback } from 'react';

import { twMerge } from 'tailwind-merge';

import { useNavigate, useSearchParams } from 'react-router-dom';

import { TbChevronRight } from 'react-icons/tb';

import { createLocale } from 'locales';

import Typography from 'components-new/typography/typography';
import Button from 'components-new/button/button';

import { STATIC_FILES_URL } from 'constants/signup-flow-constants';

import Diplomas2007Instructions from '../components/diplomas-2007-instructions';

import FreelancerSignUpPageContainer from '../components/freelancer-sign-up-page-container';
import HeaderDialog from '../components/freelancer-sign-up-page-container/header-dialog';
import Diplomas2008Instructions from '../components/diplomas-2008-instructions';
import ForeignDiplomasInstructions from '../components/foreign-diplomas-instructions';
import DiplomasInformationDialog from '../components/diplomas-information-dialog';

import freelancerRoutes from '../freelancer-routes';

const localize = createLocale('freelancerDiplomasYearSelectionPageLocales');
const globalLocalize = createLocale('global');

const DiplomasYearSelection: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams({});
  const [dialogTitle, setDialogTitle] = useReducer(
    (prev: string, newTitle: string) => {
      return newTitle;
    },
    '',
  );

  const videoUrl = `${STATIC_FILES_URL}videos/signupflow/h7.mp4`;
  const videoPreviewImageURL = `${window.STATIC_URL}assets/signupflow/h7.png`;

  const display2007DiplomaInstructions = useCallback(() => {
    setDialogTitle('Diploma na 2007');
    setSearchParams({
      diplomasInstructions: 'true',
      show2007Instructions: 'true',
    });
  }, [setDialogTitle, setSearchParams]);

  const display2008DiplomaInstructions = useCallback(() => {
    setDialogTitle('Diploma voor 2007');
    setSearchParams({
      diplomasInstructions: 'true',
      show2008Instructions: 'true',
    });
  }, [setDialogTitle, setSearchParams]);

  const displayForeignDiplomaInstructions = useCallback(() => {
    setDialogTitle('Buitenlands diploma');
    setSearchParams({
      diplomasInstructions: 'true',
      showForeignInstructions: 'true',
    });
  }, [setDialogTitle, setSearchParams]);

  const navigate = useNavigate();
  const goToAddDiplomasPage = useCallback(() => {
    navigate(freelancerRoutes.addDiplomasDocument.path);
  }, [navigate]);

  const closeInstructionsDialog = useCallback(() => {
    setSearchParams({});
  }, [setSearchParams]);

  const buttonsClassName = twMerge(
    'flex flex-row justify-between items-center w-full h-10 gap-2 py-2 px-8',
    'border border-[#979699] bg-background mt-6',
  );
  const labelsClassName = twMerge('text-body-medium text-gray700');

  const goBackToDiplomaInfo = useCallback(() => {
    navigate(freelancerRoutes.diplomasInformation.path);
  }, [navigate]);

  const shouldOpenDialog =
    (searchParams.get('showInstructionsDialog') === 'true' ||
      searchParams.get('diplomasInstructions') === 'true') &&
    dialogTitle !== '';

  return (
    <FreelancerSignUpPageContainer
      showHeader
      showGoBackButton
      onGoBackClick={goBackToDiplomaInfo}
      headerTitle={localize('title')}
      dialogInstructions={{
        component: <DiplomasInformationDialog />,
      }}
      videoInstructions={{
        url: videoUrl,
        videoPreviewImageURL,
      }}
    >
      <Typography
        as="h3"
        variant="body-medium-bold"
        className="text-gray500  w-full h-10 mt-6"
      >
        {localize('helperMessage')}
      </Typography>
      <Button
        type="button"
        variant="secondary"
        label={localize('nlDiplomaAfter2007')}
        labelClassName={labelsClassName}
        className={buttonsClassName}
        rightIconProps={{ icon: TbChevronRight }}
        onClick={display2007DiplomaInstructions}
      />
      <Button
        type="button"
        variant="secondary"
        label={localize('nlDiplomaFor2008')}
        labelClassName={labelsClassName}
        className={buttonsClassName}
        rightIconProps={{ icon: TbChevronRight }}
        onClick={display2008DiplomaInstructions}
      />
      <Button
        type="button"
        variant="secondary"
        label={localize('foreignDiploma')}
        labelClassName={labelsClassName}
        className={buttonsClassName}
        rightIconProps={{ icon: TbChevronRight }}
        onClick={displayForeignDiplomaInstructions}
      />
      <HeaderDialog
        onCloseClicked={closeInstructionsDialog}
        isOpen={shouldOpenDialog}
        title={dialogTitle}
        buttonProps={{
          label: globalLocalize('continue'),
          onClick: goToAddDiplomasPage,
          variant: 'primary',
        }}
        className="max-w-[90%] lg:max-w-[60%] overflow-scroll max-h-[90%] my-5 lg:my-0"
        footerClassName="flex justify-end items-center"
      >
        {searchParams.get('show2007Instructions') === 'true' && (
          <Diplomas2007Instructions />
        )}
        {searchParams.get('show2008Instructions') === 'true' && (
          <Diplomas2008Instructions />
        )}
        {searchParams.get('showForeignInstructions') === 'true' && (
          <ForeignDiplomasInstructions />
        )}
      </HeaderDialog>
    </FreelancerSignUpPageContainer>
  );
};

export default DiplomasYearSelection;
